import UserService from '@/services/modules/users.service';

const all = async ({ commit }) => {
    const response = UserService.getMenu();

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

export default {
    all
};